module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QQDDB4ELM9pCwAAAC1JREFUOMtj/P//PwMlgImBQkCxAYwMDAz/h7YXWEIZ6od4LIxGIwMD49DPTACDBwjr92du7wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_apb_glp.png
// module id = lCg9
// module chunks = 0